<template lang="pug">
#modal-qrcode.modal.fade(tabindex='-1' aria-hidden='true')
  .modal-dialog.modal-dialog-centered
    .modal-content
      .modal-body
        .qr-header 
          .fa.fa-qrcode.mx-1 
          | {{ $t('ui.qrcode') }}
        .form-field.pt-2
          .form-label URL
          .input-group
            input.form-control#url(type='text' :value='urlLink' readonly)
          .d-flex.justify-content-end.pt-2
            .btn-form
              a(href='javascript:void(0);' @click="copy")
                .btn-submit {{ $t('ui.copy') }}
        .form-label {{ $t('ui.qrcode') }}
        .qr-code-wrapper
          #qrcode
            img(:src='urlImg')
        .d-flex.justify-content-end.pt-2
          .btn-form
            a#qrlink(href='javascript:void(0);' @click="saveImage($event)")
              .btn-submit {{ $t('ui.save') }}
</template>

<script>
import QRCode from 'qrcode'

export default {
  data() {
    return {
      urlLink: "",
      urlImg: ""
    }
  },
  computed: {
		isLoggedIn(){
      return this.$store.getters.isLoggedIn
    },
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
  },
  created() {
  },
  mounted() {
    let vm = this
    $('#modal-qrcode').on('shown.bs.modal', function (e) { 
      vm.generateQRCode()
    })
  },
  methods: {
    generateRandomCharacters(length) {
      const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
      let result = ''
      for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * characters.length))
      }
      return result
    },
    generateQRCode() {
      if (this.isLoggedIn) {
        // Generate random characters for front and behind
        const randomFront = this.generateRandomCharacters(4)
        const randomBehind = this.generateRandomCharacters(4)

        // Encode the string with Base64
        const encodedString = btoa(this.accountID)

        // Concatenate random characters with the original string
        const stringToEncode = randomFront + encodedString + randomBehind        

        let path = window.location.origin
        let qrcode_url = path + "/registration?a=" + stringToEncode
        this.urlLink = qrcode_url
        QRCode.toDataURL(qrcode_url, (err, url) => {
          this.urlImg = url
        });
      }
    },
    saveImage(e) {
      var qrlink = $('#qrlink')
      var qrcode = $('#qrcode img')
      qrlink.attr('href', qrcode.attr('src'))
      qrlink.attr('download', 'qrcode')
    },
    copy() {
      // Get the text input element
      var inputElement = document.getElementById('url');

      // Select the text in the input element
      inputElement.select();
      inputElement.setSelectionRange(0, 99999); // For mobile devices

      // Copy the selected text to the clipboard
      document.execCommand('copy');

      // Deselect the text
      inputElement.setSelectionRange(0, 0);

      // Provide some visual feedback (optional)
      alert(this.$tc("ui.tooltips.copy_qrcode"))
    }
  }
}
</script>